<template>

  <div v-if="favorites.length > 0"  class="mb-4 w-lg-95 w-xl-100 mx-auto border-bottom">

    <div class="mb-3">
      <h2 class="text-center mb-0 text-primary">Raccourcis</h2>
    </div>

    <div class="row">


      <a href="#"
         v-if="customer_id"
         class="col-sm-6 col-xl-12 mb-2" target="_blank" title="Ma e-carte" data-toggle="modal" data-target="#memberCard">
        <!-- Favorites -->
        <div class="bg-img-hero rounded text-white text-center h-100">
          <div class="w-100">
            <div class="mb-4">
              <h3><i class="fas fa-address-card"></i>&nbsp; Ma e-Carte</h3>
            </div>
          </div>
        </div>
        <!-- End Flash -->
      </a>

      <a v-for="favorite in favorites"
          :href="favorite.url"
         class="col-sm-6 col-xl-12 mb-2" target="_blank">
        <!-- Favorites -->
        <div class="bg-img-hero rounded text-white p-3 h-100"
             :style="'background-image: url(' + favorite.picture_url +'); background-size: contain;'">
          <div class="w-100">
            <div class="mb-4">
              <h3 class="text-primary text-center">{{favorite.title}}</h3>
            </div>
          </div>
        </div>
        <!-- End Flash -->
      </a>

    </div>
  </div>

</template>

<script>

export default {
  props: [
    'customer_id',
  ],
  data: function () {
    return {
      favorites: [],
    }
  },
  mounted() {
    if (parseInt(this.customer_id, 10) > 0 ) {
      this.get_data()
    }
  },


  methods: {
    get_data: async function () {

      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "/favorites.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.favorites = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },
  }
}
</script>
